import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a05584c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "draw-new-info"
};
const _hoisted_3 = {
  class: "tit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "draw-new-box",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goDrawInfo && $options.goDrawInfo(...args))
  }, [_createElementVNode("img", {
    class: "draw-new-img",
    src: $options.imgUrlFilter($props.drawInfo.img, 187 * $data.radio)
  }, null, 8, _hoisted_1), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString($props.drawInfo.title), 1)])]);
}